import {HttpClient} from '@angular/common/http';
import {DataService} from './dataIcar.service';
import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {Injectable, Output, EventEmitter} from '@angular/core';

@Injectable()
export class CallService {

  constructor(
    private httpclient: HttpClient,
    private dataIcar: DataService
  ) {
  }

  public senData(): Observable<any> {

    const url = '';

    var data = {
      'requestType': 'FaceComparison',
      'listDocuments': [
        {
          'documentType': 'DNI',
          'listImagen': [
            {
              'imageData': '',
              'fileName': '15732046673.jpg',
              'fileType': 'JPG',
              'documentPart': 'BACK'
            },
            {
              'imageData': '',
              'fileName': '15732046679.jpg',
              'fileType': 'JPG',
              'documentPart': 'FRONT'
            }
          ]

        },
        {
          'documentType': 'TEST-LIFE',
          'listImagen': [
            {
              'imageData': '',
              'fileType': 'JPG'
            }
          ]
        }
      ]
    };

    /*
     var data = {
         "requestType": "MobileFill",
         "listDocuments": [
             {
                 "documentType": "DNI",
                 "listImagen": [
                     {
                         "imageData": "",
                         "fileName": "15732046673.jpg",
                         "fileType": "JPG",
                         "documentPart": "BACK"
                     },
                     {
                         "imageData": "",
                         "fileName": "15732046679.jpg",
                         "fileType": "JPG",
                         "documentPart": "FRONT"
                     }
                 ]

             }
         ]
     }
     */

    // anverso
    data.listDocuments[0].listImagen[0].imageData = this.dataIcar.storageData[1];
    // reverso
    data.listDocuments[0].listImagen[1].imageData = this.dataIcar.storageData[0];
    // face
    data.listDocuments[1].listImagen[0].imageData = this.dataIcar.storageData[2];
    // llamada
    console.log(data);
    return this.httpclient.post(url, data);
    //return new Observable((observer) => {observer.next()});

  }

}
